module.exports = __webpack_public_path__ + "img/hhnm_gallery0.da15f449.jpg";